<script setup lang="ts">
import { IScore } from "~/types/sports/score";
import calculateTotalSets from "~/utils/sport/calculateTotalSets";

interface Props {
	score: IScore | undefined;
}

const props = defineProps<Props>();

const scoreDivider = tw`w-[1px] h-2 bg-light-300 mx-[1px] dark:bg-dark-500`;
const scoreItem = tw`text-center`;

const setScores = computed(() => props.score && calculateTotalSets(props.score));
</script>

<template>
	<div v-if="score?.sportType !== 'cricket'" class="flex justify-end flex-1 gap-[2px] items-center text-dark-300 dark:text-light-600">
		<strong v-if="setScores?.shouldDisplayFirstSet" :class="['text-identity', scoreItem]">
			{{ setScores?.home }}<br />
			{{ setScores?.away }}
		</strong>
		<strong v-else-if="score?.score" :class="['text-identity', setScores?.shouldDisplayFirstSet ? scoreItem : 'text-right']">
			{{ score?.score[0] }}<br />
			{{ score?.score[1] }}
		</strong>
		<!-- 1st Set -->
		<div v-if="setScores?.shouldDisplayFirstSet && !setScores.shouldDisplaySecondSet" :class="scoreDivider" />
		<span v-if="setScores?.shouldDisplayFirstSet && !setScores.shouldDisplaySecondSet" :class="scoreItem">
			{{ score?.firstSet[0] }}<br />
			{{ score?.firstSet[1] }}
		</span>
		<!-- 2nd Set -->
		<div v-if="setScores?.shouldDisplaySecondSet && !setScores.shouldDisplayThirdSet" :class="scoreDivider" />
		<span v-if="setScores?.shouldDisplaySecondSet && !setScores.shouldDisplayThirdSet" :class="scoreItem">
			{{ score?.secondSet[0] }}<br />
			{{ score?.secondSet[1] }}
		</span>
		<!-- 3rd Set -->
		<div v-if="setScores?.shouldDisplayThirdSet && !setScores.shouldDisplayFourthSet" :class="scoreDivider" />
		<span v-if="setScores?.shouldDisplayThirdSet && !setScores.shouldDisplayFourthSet" :class="scoreItem">
			{{ score?.thirdSet[0] }}<br />
			{{ score?.thirdSet[1] }}
		</span>
		<!-- 4th Set -->
		<div v-if="setScores?.shouldDisplayFourthSet && !setScores.shouldDisplayFifthSet" :class="scoreDivider" />
		<span v-if="setScores?.shouldDisplayFourthSet && !setScores.shouldDisplayFifthSet" :class="scoreItem">
			{{ score?.fourthSet[0] }}<br />
			{{ score?.fourthSet[1] }}
		</span>
		<!-- 5th Set -->
		<div v-if="setScores?.shouldDisplayFifthSet" :class="scoreDivider" />
		<span v-if="setScores?.shouldDisplayFifthSet" :class="scoreItem">
			{{ score?.fifthSet[0] }}<br />
			{{ score?.fifthSet[1] }}
		</span>
		<!-- Display Points -->
		<div v-if="score?.displayedPoints" :class="scoreDivider" />
		<span v-if="score?.displayedPoints" :class="scoreItem">
			{{ score?.displayedPoints[0] }}<br />
			{{ score?.displayedPoints[1] }}
		</span>
	</div>
</template>
